import { ref, watch } from 'vue';

export const calendarSearchQuery = ref('');
export const calendarSearchResultIds = ref<Set<string>>(new Set());

watch(calendarSearchQuery, () => {
  calendarSearchResultIds.value = new Set();
});
